import {createSelector} from "reselect";
import { getChannelManagerIdSelector, getChannelManagerLinkSelector } from "../CalendarPercent/selectors";

export const getAvailibilityObjectsSelector = (state) => {
    return state.busyCalendar.objects
}


export const getObjectIdSelector = (state) => {
    return state.busyCalendar.objectId
}



export const getRoomsListSelector = (state) => {
    let roomsList = state.busyCalendar.rooms

    if (roomsList) {
        let newRoomsList = []
        Object.keys(roomsList).map(item => {
            newRoomsList.push({id: roomsList[item].id, name: roomsList[item].name})
        })

        return newRoomsList
    }
}

export const getRoomIdSelector = (state) => {
    return state.busyCalendar.room
}



export const getDatesAllSelector = (state) => {
    return state.busyCalendar.availability?.availability
}

export const getDatesSelector = createSelector(getChannelManagerIdSelector, getDatesAllSelector,(channelManager, avalability) => {
    if(!avalability){
        return
    }
    let finishAvailability = {...avalability}
    if(channelManager && avalability) {
        Object.keys(avalability).forEach(date => {
            finishAvailability = {...finishAvailability, [date]: {...finishAvailability[date], disabled: true}}
        })
    }
    return finishAvailability
})

export const getAvailabilitiesIdSelector = (state) => {
    return state.busyCalendar.availability?.ids
}

export const getRoomNameBusySelector = createSelector(getRoomsListSelector, getRoomIdSelector, (roomList, roomId) => {
    if(!roomList || !roomId) {
        return
    }

    return roomList.filter(item => item.id == roomId)[0]?.name
})